export enum EHeaderDBMaster {
    AUTHORIZATION_AM = 'x-am-authorization',
    AUTHORIZATION_AM_USER = 'x-am-user-authorization',
    AUTHORIZATION_AWS = 'x-aws-authorization',
    AUTHORIZATION_GOOGLE = 'x-google-authorization',
    AUTHORIZATION_AZURE = 'x-azure-authorization',
    DB_MASTER_NAME = 'db-master-name',
    ADMIN_PATH = 'admin-path',
    THEME = 'theme',
    WAIT_FOR_PARENT_READY = 'wait-for-parent-ready',
    SHOW_LOGS = 'show-logs',
}
